import styled from 'styled-components';
import { rem } from 'polished';
// import AvatarPerson from '../AvatarPerson';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import Icon from '../Icon';

const StyledHeaderDirectory = styled.div`
  display: none;
  ${mediaqueries.greaterThan('tabletLandscape')`
     display: table-header-group;
  `};
`;

const StyledHeaderItem = styled.div`
  border-bottom: ${rem('1px')} solid ${props => props.theme.colors.dark};
  display: table-cell;
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('14px')};
  overflow: hidden;
  padding: ${rem('0px')} ${rem('10px')};
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const StyledTableWrapper = styled.div`
  ${mediaqueries.greaterThan('tabletLandscape')`
    display: table;
    width: 100%;
  `};
  ${mediaqueries.lessThan('tabletLandscape')`
    margin-top: ${props => props.isWidget !== true && '50px'};
  `};
`;

const StyledNotificationWidget = styled.div`
  background-color: ${props => props.theme.colors.grayDarkest};
  color: ${props => props.theme.colors.light};
  border-right: ${rem('4px')} solid ${props => props.theme.colors.primary};
  cursor: pointer;
  margin: 20px 0px 20px 0px;
  display: flex;
  padding: 20px;
`;

const StyledNotificationDirectory = styled.div`
  ${props =>
    props.active &&
    `
    max-height: none;
  `};

  ${mediaqueries.lessThan('mobile')`
    background-color: #fbfbfb;
    border-bottom-color: #e7e7e7;
    border-bottom: 0.5px solid #e7e7e7;
    padding: 2.6875rem;
    padding-bottom: 0;
    overflow-y: auto;
    max-height: none;
    overflow: auto;
    width: 100%;
    display: flex;
  `};
  ${mediaqueries.greaterThan('mobile')`
    background-color: #fbfbfb;
    border-bottom-color: #e7e7e7;
    border-bottom: 0.5px solid #e7e7e7;
    display: inline-flex;
    max-width: inherit;
    padding: 1.6875rem 0;
    padding-bottom: 0;
    overflow-y: auto;
    max-height: none;
    overflow: auto;
    width: 100%;
  `};
  ${mediaqueries.greaterThan('tabletLandscape')`
    background-color: ${props => props.theme.colors.grayMoreLight};
    border-bottom-color: ${props => props.theme.colors.grayLighter};
    display: table-row-group;
    max-width: inherit;
    padding: ${rem('11px')};
    max-height: none;
    overflow: auto;
  `};
  ${mediaqueries.lessThan('mobile')`
    background-color: #fbfbfb;
    border-bottom-color: #e7e7e7;
    border-bottom: 0.5px solid #e7e7e7;
    display: inline-flex;
    max-width: inherit;
    padding: 1.6875rem 0;
    padding-bottom: 0;
    overflow-y: auto;
    max-height: none;
    overflow: auto;
    width: 100%;
  `};
`;

const StyledIconDot = styled.span`
  margin-top: 20px;
  margin-left: 25px;
  margin-right: 15px;
  margin-bottom: 5px;
  height: 10px;
  width: 10px;
  display: inline-block;
  border-radius: 50%;
  border-style: solid;
  border-width: 0.5px;
  border-color: transparent;
  background-color: transparent;
  ${props =>
    props.viewed === false &&
    `
    border-radius: 50%;
    border-style: solid;
    border-width: 0.5px;
    border-color: ${props.theme.colors.secondary};
    background-color: ${props.theme.colors.secondary};
  `};
  ${mediaqueries.lessThan('tabletLandscape')`
    margin-top: 6px;
    margin-left: 25px;
    width: 20px;
  `};
  ${mediaqueries.lessThan('greatherTablet')`
    margin-top: 7px;
    margin-left: 25px;
    width: 25px;
  `};
  ${mediaqueries.lessThan('mobile')`
    margin-top: 7px;
    margin-left: 25px;
    width: 45px;
  `};
`;

const StyledNamesWraper = styled.div`
  margin-right: ${rem('20px')};
  width: 77%;

  ${mediaqueries.greaterThan('tabletLandscape')`
    display: table;
    width: 100%;
  `};
`;

const StyledEmployerName = styled.div`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('14px')};
  max-width: ${rem('120px')};
  ${mediaqueries.greaterThan('tabletLandscape')`
    border-bottom: ${rem('1px')} solid ${props =>
    props.theme.colors.grayLighter};
    display: table-cell;
    font-family: ${props => props.theme.fonts.book};
    margin-right: ${rem('20px')};
    overflow: hidden;
    padding: ${rem('15px')} ${rem('10px')};
    text-overflow: ellipsis;
    vertical-align: middle;
    white-space: nowrap;
  `};
  ${mediaqueries.greaterThan('desktop')`
    width: ${rem('120px')};
  `};
`;

const StyledNotificationDate = styled.div`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('14px')};
  max-width: ${rem('120px')};
  ${props =>
    props.isWidget === true &&
    `
    border-bottom: 0px solid transparent;
    margin-left: 20px;
  `}
  ${mediaqueries.greaterThan('tabletLandscape')`
     border-bottom: ${rem('1px')} solid ${props =>
    props.isWidget !== true
      ? props.theme.colors.grayLighter
      : '0px solid transparent'};
    display: table-cell;
    font-family: ${props => props.theme.fonts.book};
    margin-right: ${rem('20px')};
    overflow: hidden;
    padding: ${rem('15px')} ${rem('10px')};
    text-overflow: ellipsis;
    vertical-align: middle;
    white-space: nowrap;
  `};
  ${mediaqueries.greaterThan('desktop')`
    // width: ${rem('120px')};
  `};
  ${mediaqueries.lessThan('mobile')`
    width: 100%;
  `};
`;

const StyledNotificationType = styled.div`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('14px')};
  max-width: ${rem('240px')};
  ${props =>
    props.isWidget === true &&
    `
  border-bottom: 0px solid transparent;
  `}
  ${mediaqueries.greaterThan('tabletLandscape')`
  border-bottom: ${rem('1px')} solid ${props =>
    props.isWidget !== true
      ? props.theme.colors.grayLighter
      : '0px solid transparent'};
  display: table-cell;
  font-family: ${props => props.theme.fonts.book};
  margin-right: ${rem('20px')};
  overflow: hidden;
  padding: ${rem('15px')} ${rem('10px')};
  text-overflow: ellipsis;
  vertical-align: middle;
  white-space: nowrap;
`};
  ${mediaqueries.greaterThan('desktop')`
  // width: ${rem('120px')};
`};
  ${mediaqueries.greaterThan('mobile')`
    margin-left: 20px;
  `};
  ${mediaqueries.lessThan('mobile')`
    margin-left: 20px;
    width: 100%;
  `};
`;

const StyledNotificationTitle = styled.div`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('14px')};
  max-width: ${rem('560px')};
  ${props =>
    props.isWidget === true &&
    `
    border-bottom: 0px solid transparent;
    margin-left: 20px;
    max-width: 240px;
    word-break: keep-all;
    width: 100%;
  `}
  ${mediaqueries.greaterThan('tabletLandscape')`
     border-bottom: ${rem('1px')} solid ${props =>
    props.isWidget !== true
      ? props.theme.colors.grayLighter
      : '0px solid transparent'};
    display: table-cell;
    font-family: ${props => props.theme.fonts.book};
    margin-right: ${rem('20px')};
    overflow: hidden;
    padding: ${rem('15px')} ${rem('10px')};
    vertical-align: middle;
  `};
  ${mediaqueries.greaterThan('desktop')`
    // width: ${rem('120px')};
  `};
  ${mediaqueries.greaterThan('mobile')`
    margin-left: 20px;
    width: 100%;
  `};
  ${mediaqueries.lessThan('mobile')`
    margin-left: 20px;
    width: 100%;
  `};
`;

const StyledNotificationSubtitle = styled.div`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('14px')};
  max-width: ${rem('560px')};
  ${props =>
    props.isWidget === true &&
    `
    border-bottom: 0px solid transparent;
    margin-left: 20px;
    padding-right: 10px;
    whiteSpace: nowrap;
    overflow: hidden;
    textOverflow: ellipsis;
    width: 100%;
    font-size: ${rem('10px')};
  `}
  ${mediaqueries.greaterThan('tabletLandscape')`
     border-bottom: ${rem('1px')} solid ${props =>
    props.isWidget !== true
      ? props.theme.colors.grayLighter
      : '0px solid transparent'};
    display: table-cell;
    font-family: ${props => props.theme.fonts.book};
    margin-right: ${rem('20px')};
    overflow: hidden;
    padding: ${rem('15px')} ${rem('10px')};
    text-overflow: ellipsis;
    vertical-align: middle;
    white-space: nowrap;
  `};
  ${mediaqueries.greaterThan('desktop')`
    // width: ${rem('120px')};
  `};
  ${mediaqueries.greaterThan('mobile')`
    margin-left: 20px;
  `};
`;

const StyledWrapperFlex = styled.div``;

const StyledEmployerLastName = styled(StyledEmployerName)`
  max-width: ${rem('186px')};
  ${mediaqueries.greaterThan('desktop')`
    width: ${rem('186px')};
  `};
`;

const StyledEmployerTableCell = styled.div`
  display: inline-flex;
  font-family: ${props => props.theme.fonts.book};
  font-size: ${rem('14px')};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  ${mediaqueries.lessThan('desktop')`
    display: inline-flex;
    margin-left: 1rem;
    vertical-align: middle;
    margin-top: 15px;
}
  `};
  ${mediaqueries.greaterThan('mobile')`
    margin-left: 20px;
  `};
`;

const StyledEmployerTableCellProfile = styled(StyledEmployerTableCell)`
  max-width: ${rem('186px')};
  ${mediaqueries.greaterThan('desktop')`
    width: ${rem('186px')};
  `};
`;

const StyledEmployerTableCellDepartment = styled(StyledEmployerTableCell)`
  max-width: ${rem('230px')};
  ${mediaqueries.greaterThan('desktop')`
    width: ${rem('230px')};
  `};
`;

const StyledEmployerTableCellExtension = styled(StyledEmployerTableCell)`
  max-width: ${rem('72px')};
  ${mediaqueries.greaterThan('desktop')`
    width: ${rem('72px')};
  `};
`;

const StyledEmployerTableCellPhones = styled(StyledEmployerTableCell)`
  max-width: ${rem('150px')};
  ${mediaqueries.greaterThan('desktop')`
    width: ${rem('150px')};
  `};
`;

const StyledEmployerTableCellEmail = styled(StyledEmployerTableCell)`
  max-width: 98%;
  ${mediaqueries.greaterThan('desktop')`
     max-width: ${rem('230px')};
     width: ${rem('230px')};
  `};
`;

const StyledWrapperPhoto = styled(StyledEmployerTableCell)`
  display: inline;
  ${mediaqueries.greaterThan('tabletLandscape')`
     display: table-cell;
  `};
  ${mediaqueries.greaterThan('desktop')`
    width: ${rem('40px')};
  `};
`;

const StyledIcon = styled(Icon)`
  margin-top: ${rem('15px')};

  &:first-child {
    margin-right: ${props =>
      props.isWidget !== true ? rem('15px') : rem('1.6px')};
    margin-top: ${props =>
      props.isWidget !== true ? rem('0px') : rem('9,6px')};
    height: ${props => props.isWidget === true && '35px'};
  }
`;

const StyledImg = styled.img`
  border-radius: 50px;
  width: 50px;
  height: 50px;
`;

const StyledNotificationActions = styled.div`
  display: flex;
  ${mediaqueries.lessThan('desktop')`
    margin-top: -15px;
    height: 60px;
    margin-left: 25px;
    display: flex;
    justify-content: flex-end;
    margin-left: auto;
  `}
`;

const StyledRoundedIcon = styled.div`
  width: 65px;
  justify-content: center;
  display: flex;
  height: 50px;
  background-color: white;
  border-radius: 50px;
`;

const StyledNumNotifications = styled.div`
  color: ${props => props.theme.colors.light};
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('14px')};
`;

export {
  StyledNumNotifications,
  StyledNotificationDirectory,
  StyledNotificationWidget,
  StyledNotificationActions,
  StyledNamesWraper,
  StyledNotificationDate,
  StyledNotificationType,
  StyledNotificationTitle,
  StyledNotificationSubtitle,
  StyledEmployerName,
  StyledEmployerLastName,
  StyledEmployerTableCell,
  StyledEmployerTableCellProfile,
  StyledEmployerTableCellDepartment,
  StyledEmployerTableCellExtension,
  StyledEmployerTableCellPhones,
  StyledEmployerTableCellEmail,
  StyledHeaderDirectory,
  StyledHeaderItem,
  StyledTableWrapper,
  StyledWrapperPhoto,
  StyledRoundedIcon,
  StyledIcon,
  StyledImg,
  StyledIconDot,
  StyledWrapperFlex
};
